import { formEncode, getToken, handleResponse, nextJsonApi } from '@/API/core';
import { FinancialTimeBasedReport } from '@/lib/types';

const reports = {
  fetchFinancialBasedOnDateOfSubmission: async (
    data: FinancialTimeBasedReport
  ) => {
    let response = null;
    const token = await getToken();
    try {
      response = await nextJsonApi.post(
        '/reports/financial-time-based-report',
        formEncode(data),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
};

export default reports;
